export const SHOW_MODAL = 'list_select_modal_show';
export const HIDE_MODAL = 'list_select_modal_hide';
export const SET_LISTS_REQUEST_STATUS = 'list_select_modal_set_lists_request_status';
export const STORE_LISTS = 'list_select_modal_store_lists';
export const STORE_SELECTED_LIST = 'list_select_modal_store_selected_list';
export const CLEAR_LISTS = 'list_select_modal_clear_lists';
